import { createPortal } from "react-dom";
import { SystemLanguage } from "../../common/system-language";
import "./ProactiveOverlay.css";

const translations: Record<string, Record<string, string>> = {
  en: {
    button: "Start Conversation",
  },
  ar: {
    button: "ابدأ المحادثة",
  },
};

export interface ProactiveOverlayProps {
  open: boolean;
  onStart: () => void;
  disabled?: boolean;
  systemLanguage?: SystemLanguage;
}

export function ProactiveOverlay({
  open,
  onStart,
  disabled = false,
  systemLanguage = "en",
}: ProactiveOverlayProps) {
  if (!open) return null;

  const t = (key: string) =>
    translations[systemLanguage]?.[key] || translations.en[key] || key;

  return createPortal(
    <div
      className="proactive-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={t("button")}
    >
      <button
        type="button"
        className="proactive-overlay__button"
        onClick={onStart}
        disabled={disabled}
      >
        {t("button")}
      </button>
    </div>,
    document.body
  );
}

export default ProactiveOverlay;
